export const REACT_APP_GOOGLE_DRIVE_API_KEY="AIzaSyDMqRLutKAzLHYZrXSbvnakhZsQX2WaZx0"
export const REACT_APP_GOOGLE_DRIVE_CLIENT_ID="581210145494-bhvk1hjrirjshbvn5rblccgag1or62np.apps.googleusercontent.com"
